import React from "react";
import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { ScrollingText } from "@common/scrollingText";
import { Props } from "./types";
import { Checkbox } from "@common/checkbox";
import styles from "./styles.scss";
import classNames from "classnames";

function Task({
  project,
  task,
  depth = 1,
  isChecked,
  toggleTaskSelection,
}: Props) {
  const { pushView } = useModal();

  return (
    <div className={styles.list}>
      <div className={styles.main}>
        <div
          className={styles.header}
          style={{ paddingLeft: `${depth === 0 ? 4 : (depth - 1) * 3 + 4}rem` }}
        >
          <div
            className={styles.checkbox}
            onClick={(e) => {
              e.stopPropagation();
              toggleTaskSelection(task);
            }}
          >
            <Checkbox isChecked={isChecked} />
          </div>
          <div className={styles.nameContainer}>
            <ScrollingText speed={100}>
              <p
                className={classNames(styles.name, {
                  [styles.selected]: isChecked,
                })}
                onClick={() =>
                  pushView({
                    key: UseCases.retrieveTask,
                    data: { task },
                  })
                }
              >
                {task.name}
              </p>
            </ScrollingText>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Task };
